import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './style.scss';

const Config = () => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    return (
        <div className="config container">
            <div className="title">
                <h1>{strings.CONFIGURATIONS}</h1>
            </div>
            <div className="card">
                <Link className="config-menu-item" to="/config/customization">
                    <i className="material-icons-outlined menu-icon">brush</i>
                    <span>{strings.SYSTEM_CUSTOMIZATION}</span>
                    <i className="material-icons-outlined">keyboard_arrow_right</i>
                </Link>

                <Link className="config-menu-item" to="/config/categories">
                    <i className="material-icons-outlined menu-icon">label</i>
                    <span>{strings.CATEGORY_MANAGEMENT}</span>
                    <i className="material-icons-outlined">keyboard_arrow_right</i>
                </Link>
            </div>
        </div>
    );
};

export default Config;
